import { Col, Label, ReactSelectBox } from "client/CommonComponents";

const TreeCare = (props?: any) => {
  const managedEquipmentValues = props?.managedEquipmentValues;
  const equipmentTypeDropDownList = props?.equipmentTypeDropDownList;
  const manufacturerDropDownList = props?.manufacturerDropDownList;
  const horsePowerDropDownList = props?.horsePowerDropDownList;
  const fuelTypeDropDownList = props?.fuelTypeDropDownList;
  const managedEquipRef = props?.managedEquipRef;
  const handleManufacturerChange = props?.handleManufacturerChange;
  const handleEquipmentTypeChange = props?.handleEquipmentTypeChange;
  const handleHorsePowerChange = props?.handleHorsePowerChange;
  const handleFuelTypeChange = props?.handleFuelTypeChange;

  return (<>
     <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label data-attribute="TreeCare_Default_Label_5">Manufacturer</Label>
        <ReactSelectBox
          options={manufacturerDropDownList}
          onChange={(item: any, e: any) => handleManufacturerChange(e, item,'manufacturer')}
          value={managedEquipmentValues?.manufacturer}
          selectRef={(element:any)=> managedEquipRef.current[1] = element}

         data-attribute="TreeCare_Default_SearchSelectBox_5" />
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
        <Label data-attribute="TreeCare_Default_Label_2_2">Equipment Type</Label>
        <ReactSelectBox
          options={equipmentTypeDropDownList}
          onChange={(item: any, e: any) => handleEquipmentTypeChange(e, item,'treeCareEquipmentType')}
          value={managedEquipmentValues?.treeCareEquipmentType}
          selectRef={(element:any)=> managedEquipRef.current[2] = element}

         data-attribute="TreeCare_Default_SearchSelectBox_6" />
      </Col>
      <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
          <Label data-attribute="TreeCare_Default_Label_3_2">Horse Power</Label>
          <ReactSelectBox
            options={horsePowerDropDownList}
            onChange={(item: any, e: any) => handleHorsePowerChange(e, item,'horsePower')}
            value={managedEquipmentValues?.horsePower}
            selectRef={(element:any)=> managedEquipRef.current[3] = element}
            isSearchable = {true}
           data-attribute="TreeCare_Default_SearchSelectBox_7" />
        </Col>
        <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
          <Label data-attribute="TreeCare_Default_Label_4_2">Fuel Type</Label>
          <ReactSelectBox
            options={fuelTypeDropDownList}
            onChange={(item: any, e: any) => handleFuelTypeChange(e, item,'fuelType')}
            value={managedEquipmentValues?.fuelType}
            selectRef={(element:any)=> managedEquipRef.current[4] = element}
           data-attribute="TreeCare_Default_SearchSelectBox_8" />
        </Col>
  </>)
}

export default TreeCare;
